import { Button } from "@mui/material";
import AddUserDialog from "./AddUserDialog";
import { FormattedMessage as T } from "react-intl";
import { useBoolean } from "@knowfully/ui.common";

export function AddUser() {
  const [openAddUserDialog, setOpenAddUserDialog] = useBoolean(false);
  return (
    <>
      <Button variant="contained" onClick={setOpenAddUserDialog.setTrue}>
        <T id="addUser" />
      </Button>
      <AddUserDialog
        open={openAddUserDialog}
        onClose={setOpenAddUserDialog.setFalse}
      />
    </>
  );
}
